export default {
  site: {
    name: 'CSSSpreadsheetBR',
    tagline: 'Unabhaengige CSSBuy Ressource',
    description: 'Finden und organisieren Sie CSSBuy Spreadsheet Ressourcen an einem Ort. Entdecken Sie Produktlinks, Kategorien, Kaufanleitungen, QC, Warehouse, internationalen Versand und nuetzliche Informationen, um besser zu recherchieren, bevor Sie kaufen.',
    title: 'CSSBuy Spreadsheet: Produkte, Links & CSSBuy Guides finden',
    metaDesc: 'CSSBuy Spreadsheet: Unabhaengiger Guide mit Produktlinks, Kategorien, Bewertungen, Versand, Warehouse, Coupons und Sicherheitstipps. Recherche-Ressource vor dem Kauf.',
  },
  nav: {
    home: 'Startseite',
    shoppingGuide: 'Einkaufsguide',
    spreadsheet: 'CSSBuy Spreadsheet',
    review: 'CSSBuy Review',
    shipping: 'Versand',
    coupon: 'Gutschein',
    warehouse: 'Warehouse',
    legit: 'Ist Es Sicher?',
    guides: 'Guides',
    articles: 'Artikel',
    about: 'Ueber',
    contact: 'Kontakt',
    privacy: 'Datenschutz',
    terms: 'Nutzungsbedingungen',
  },
  hero: {
    eyebrow: 'CSSBuy Spreadsheet • Unabhaengiger Guide',
    h1: 'CSSBuy Spreadsheet: Produkte, Links & CSSBuy Guides finden',
    description: 'Finden und organisieren Sie CSSBuy Spreadsheet Ressourcen an einem Ort. Entdecken Sie Produktlinks, Kategorien, Kaufanleitungen, QC, Warehouse, internationalen Versand und nuetzliche Informationen, um besser zu recherchieren, bevor Sie kaufen.',
    ctaPrimary: 'CSSBuy Spreadsheet erkunden',
    ctaSecondary: 'CSSBuy Guides ansehen',
    searchPlaceholder: 'Produkte, Kategorien oder CSSBuy Spreadsheet suchen...',
    trust: 'Unabhaengige Ressource • Deutsche Inhalte • Aktuelle Guides • Fokus auf Sicherheit',
    ctaMainSite: 'CSSBuy Spreadsheet',
    ctaBuyNow: 'Buy It Now',
  },
  categories: {
    title: 'Beliebte Kategorien',
    subtitle: 'Finden Sie die besten Produkte nach Kategorie im CSSBuy Spreadsheet',
    shoes: 'Shoes',
    hoodies: 'Hoodies/Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
    dropdownLabel: 'Alle Kategorien',
  },
  valueProposition: {
    h2: 'Alles, was Sie brauchen, um das CSSBuy Spreadsheet zu erkunden',
    spreadsheet: 'CSSBuy Spreadsheet',
    spreadsheetDesc: 'Produkte, Links und Kategorien organisiert, um Ihre Recherche vor dem Kauf zu erleichtern.',
    guides: 'CSSBuy Guides',
    guidesDesc: 'Kaufanleitungen, QC, Warehouse und Versand, damit Sie sicher kaufen koennen.',
    review: 'CSSBuy Review',
    reviewDesc: 'Unabhaengige Informationen und Analyse ueber den Kaufprozess und Agenten.',
    safety: 'Safety',
    safetyDesc: 'Wie man Links, Verkaeufer, Produkte und Kosten vor dem Kauf ueberprueft.',
  },
  howItWorks: {
    h2: 'Wie verwendet man das CSSBuy Spreadsheet?',
    step1: 'Suchen',
    step1Desc: 'Produkte und Kategorien im CSSBuy Spreadsheet finden',
    step2: 'Ueberpruefen',
    step2Desc: 'Links, Verkaeufer, Produkt und QC vor dem Kauf pruefen',
    step3: 'Vergleichen',
    step3Desc: 'Optionen, Kosten und Informationen analysieren, um die beste Entscheidung zu treffen',
    cta: 'CSSBuy Spreadsheet erkunden',
  },
  comparison: {
    h2: 'Vergleich: Was vor dem Kauf zu pruefen ist',
    factor: 'Faktor',
    whatToCheck: 'Was zu pruefen',
    product: 'Produkt',
    productCheck: 'Link, Verkaeufer und Produktinformationen',
    qc: 'QC',
    qcCheck: 'Verfuegbare Inspektionsinformationen',
    warehouse: 'Warehouse',
    warehouseCheck: 'Lagerung und Handhabung',
    shipping: 'Versand',
    shippingCheck: 'Aktuelle Optionen und Kosten',
    coupon: 'Gutschein',
    couponCheck: 'Gueltigkeit und Berechtigung',
    safety: 'Sicherheit',
    safetyCheck: 'Ueberpruefung vor der Zahlung',
  },
  commercialCards: {
    h2: 'Meistgesuchte CSSBuy Ressourcen',
    review: 'CSSBuy Review',
    reviewDesc: 'Unabhaengige Bewertung von Prozess, Kosten und Zuverlaessigkeit.',
    shipping: 'CSSBuy Shipping Cost',
    shippingDesc: 'Verstehen Sie Gewicht, Abmessungen, Ziel, Versandlinien und Konsolidierung.',
    coupon: 'CSSBuy Coupon',
    couponDesc: 'Wie man Gutscheine und Rabattcodes findet und ueberprueft.',
    warehouse: 'CSSBuy Warehouse',
    warehouseDesc: 'Order → Seller → Warehouse → QC → Storage → Consolidation → Shipping.',
    legit: 'CSSBuy Legit',
    legitDesc: 'Bewerten Sie Informationen, Zahlungen, Support, Warehouse und Sicherheit.',
    cta: 'Mehr erfahren',
  },
  safety: {
    h2: 'Sicherheit & Ueberpruefung',
    h3: 'Wie man vor dem Kauf mit CSSBuy ueberprueft',
    description: 'Ueberpruefen Sie immer Links, Verkaeufer, Produkte und Kosten, bevor Sie bezahlen. Das CSSBuy Spreadsheet hilft Ihnen, Informationen zu organisieren und zu vergleichen, fuer einen sicheren Kauf.',
    checklist1: 'Ueberpruefen Sie den Produktlink vor dem Kauf',
    checklist2: 'Pruefen Sie Verkaeuferbewertungen',
    checklist3: 'Analysieren Sie QC (Quality Control) Fotos',
    checklist4: 'Vergleichen Sie Versandkosten zu Ihrem Land',
    checklist5: 'Pruefen Sie aktive Gutscheine und Rabattcodes',
  },
  articles: {
    h2: 'Aktuelle Artikel & Guides',
    readMore: 'Artikel lesen',
    article1Title: 'CSSBuy Spreadsheet: Kompletter Guide',
    article1Desc: 'Alles ueber das CSSBuy Spreadsheet, wie man es nutzt, Links organisiert und Produkte recherchiert.',
    article2Title: 'CSSBuy Shipping Cost: Was den Preis bestimmt',
    article2Desc: 'Gewicht, Abmessungen, Ziel, Versandlinie und deklarierter Wert erklaert.',
    article3Title: 'Is CSSBuy Legit? Praktischer Sicherheitsguide',
    article3Desc: 'Wie man bewertet, ob ein Produkt, Verkaeufer oder Link sicher ist, bevor man kauft.',
    article4Title: 'CSSBuy Coupon: Wie man Angebote findet',
    article4Desc: 'Wo man aktive Gutscheine findet, Gueltigkeit ueberprueft und Rabatte korrekt anwendet.',
    article5Title: 'CSSBuy Warehouse Guide: Lagerung und Konsolidierung',
    article5Desc: 'Wie das Warehouse funktioniert, Lagerfluss, Konsolidierung und internationaler Versand.',
    article6Title: 'CSSBuy QC Guide: Quality Control Fotos lesen',
    article6Desc: 'Worauf man bei QC-Fotos achten sollte, um die Qualitaet vor dem Versand zu pruefen.',
    article7Title: 'CSSBuy W2C Spreadsheet: Produktlinks finden',
    article7Desc: 'Was W2C bedeutet und wie man Taobao, Weidian und 1688 Links zum Kaufen nutzt.',
    article8Title: 'CSSBuy Alternatives: Andere Agenten vergleichen',
    article8Desc: 'Kriterien zum Vergleich von CSSBuy mit Superbuy, Sugargoo und anderen Agenten.',
    article9Title: 'CSSBuy Shipping to Brazil: Versand nach Brasilien',
    article9Desc: 'Zollregeln, Steuern, Versandlinien und Konsolidierung fuer Brasilien.',
    article10Title: 'CSSBuy Seller Verification: Verkaeufer pruefen',
    article10Desc: 'Anzeichen fuer vertrauenswuerdige Verkaeufer und Warnsignale.',
    article11Title: 'CSSBuy Parcel Consolidation: Versand reduzieren',
    article11Desc: 'Wie man Artikel zu einem Paket zusammenfuegt, um Versandkosten zu sparen.',
    article12Title: 'CSSBuy Beginner Handbook: Anfaenger Guide',
    article12Desc: 'Alles, was ein Anfaenger wissen muss, um ueber CSSBuy zu kaufen.',
    article13Title: 'CSSBuy Product Research: Gute Produkte finden',
    article13Desc: 'Wie man recherchiert, Preise vergleicht und Qualitaet vor dem Kauf prueft.',
    article14Title: 'CSSBuy Sneakers Spreadsheet: Sneakers Guide',
    article14Desc: 'Wie man Sneakers findet, Groesse, Qualitaet und Preis prueft.',
  },
  faq: {
    h2: 'Haeufig gestellte Fragen',
    q1: 'Was ist CSSBuy Spreadsheet?',
    a1: 'CSSBuy Spreadsheet ist eine organisierte Ressource mit Produktlinks, Kategorien und Anleitungen, um Kauefern bei der Recherche und beim Finden von Artikeln vor dem Kauf ueber den CSSBuy Agent zu helfen.',
    q2: 'Wie verwende ich CSSBuy Spreadsheet?',
    a2: 'Verwenden Sie die Suchleiste oder durchsuchen Sie Kategorien, um Produkte zu finden. Klicken Sie auf Links, um Details, Verkaeufer und QC-Fotos zu ueberpruefen, bevor Sie zum Warenkorb hinzufuegen.',
    q3: 'Ist CSSBuy serioes?',
    a3: 'CSSBuy ist ein bekannter Einkaufsagent. Diese Website ist eine unabhaengige Ressource, um Ihnen zu helfen, Links, Verkaeufer und Informationen vor dem Kauf zu ueberpruefen.',
    q4: 'Ist CSSBuy sicher?',
    a4: 'Sicherheit haengt davon ab, Links, Verkaeufer, QC-Fotos zu ueberpruefen und die Versandkosten vor der Zahlung zu verstehen. Verwenden Sie diese Anleitung, um Ihre Recherche zu organisieren.',
    q5: 'Wie funktioniert CSSBuy Versand?',
    a5: 'Der Versand haengt von Gewicht, Abmessungen, Ziel, gewaehlter Versandlinie und deklariertem Wert ab. Warehouse und Konsolidierung koennen Kosten reduzieren.',
    q6: 'Wie viel kostet CSSBuy Versand?',
    a6: 'Die Kosten variieren je nach Gewicht, Abmessungen, Zielland, Versandlinie und Versicherung. Siehe unseren vollstaendigen Versandguide fuer Schaetzungen.',
    q7: 'Was ist CSSBuy QC?',
    a7: 'QC (Quality Control) sind Inspektionsfotos des Produkts, die im Warehouse vor dem Versand gemacht werden. Sie helfen zu ueberpruefen, ob der Artikel korrekt ist.',
    q8: 'Was ist CSSBuy Warehouse?',
    a8: 'Das Warehouse ist, wo Produkte nach dem Kauf gelagert werden. Umfasst QC-Inspektion, Lagerung und Konsolidierung vor dem internationalen Versand.',
    q9: 'Wo finde ich CSSBuy Gutscheine?',
    a9: 'Gutscheine und Rabattcodes koennen in aktualisierten Guides gefunden werden. Ueberpruefen Sie immer Gueltigkeit und Einschraenkungen vor der Verwendung.',
    q10: 'Wie ueberpruefe ich CSSBuy Rabattcodes?',
    a10: 'Ueberpruefen Sie das Ablaufdatum, den Mindestkaufwert, Regionseinschraenkungen und ob der Code noch aktiv ist, bevor Sie ihn anwenden.',
  },
  ctaBanner: {
    h2: 'Bereit, das CSSBuy Spreadsheet zu erkunden?',
    description: 'Fahren Sie mit der Hauptwebsite fort, um mehr Produkte, Links und organisierte Ressourcen zu finden.',
    cta: 'Zur Hauptwebsite',
    cta2: 'Buy It Now',
  },
  footer: {
    tagline: 'Unabhaengige Ressource ueber CSSBuy Spreadsheet. Wir sind nicht mit CSSBuy verbunden oder von CSSBuy unterstuetzt.',
    links: 'Nuetzliche Links',
    legal: 'Rechtliches',
    resources: 'Ressourcen',
    about: 'Ueber',
    editorial: 'Editorial Policy',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    spreadsheet: 'CSSBuy Spreadsheet',
    review: 'CSSBuy Review',
    shipping: 'Versand',
    coupon: 'Gutschein',
    warehouse: 'Warehouse',
    legit: 'Ist Es Sicher?',
    articles: 'Artikel',
    safety: 'Sicherheit',
    copyright: 'CSSSpreadsheetBR. Unabhaengige Ressource. Nicht verbunden mit CSSBuy.',
  },
  breadcrumb: {
    home: 'Startseite',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    description: 'Die Seite, die Sie suchen, existiert nicht. Kehren Sie zur Startseite zurueck und erkunden Sie das CSSBuy Spreadsheet weiter.',
    cta: 'Zurueck zur Startseite',
  },
  general: {
    lastUpdated: 'Aktualisiert am',
    readTime: 'Min. Lesezeit',
    quickAnswer: 'Schnelle Antwort:',
    checklist: 'Checkliste',
    relatedArticles: 'Verwandte Artikel',
    tableOfContents: 'Inhalt',
    share: 'Teilen',
    author: 'Autor',
    editor: 'Editor',
    disclaimer: 'Diese Website ist eine unabhaengige Ressource und ist nicht mit CSSBuy verbunden oder von CSSBuy unterstuetzt. Die Informationen werden zu Recherche- und Organisationszwecken bereitgestellt.',
  },
  schema: {
    organization: 'CSSSpreadsheetBR',
    organizationDesc: 'Unabhaengige Ressource ueber CSSBuy Spreadsheet, Produkte, Links und Kaufanleitungen.',
    faqPage: 'Haeufig gestellte Fragen ueber CSSBuy Spreadsheet',
  },
  products: {
    eyebrow: 'Produkte Entdecken',
    title: 'Ausgewaehlte Produkte',
    description: 'Durchsuchen Sie kuratierte Produkte aus dem CSSBuy Spreadsheet. Klicken Sie auf ein Artikel, um Details anzusehen und auf der Hauptwebsite zu kaufen.',
    viewAll: 'Alle Ansehen',
    buy: 'Kaufen',
    noProducts: 'Produkte bald verfuegbar',
  },
};